import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MixDesignDto } from 'src/app/shared/models/mix-design-location.model';

@Component({
    selector: 'app-mix-design-list-dialog',
    templateUrl: './mix-design-list-dialog.component.html',
    styleUrls: ['./mix-design-list-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MixDesignListDialogComponent {
  constructor(
    private matDialogRef: MatDialogRef<MixDesignListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mixDesigns: MixDesignDto[],
  ) {}

  get locationLabel(): string {
    const [first] = this.mixDesigns;
    return [first?.city, first?.state].filter(Boolean).join(', ');
  }

  getQueryParams(mixDesign: MixDesignDto): Record<string, string> {
    return mixDesign.mixReferenceId
      ? {
        mixDesignCode: mixDesign.mixId, mixReference: mixDesign.mixReferenceId,
      }
      : {
        mixDesignCode: mixDesign.mixId,
      };
  }

  closeDialog(): void {
    this.matDialogRef.close();
  }
}
